import React, { useState, useEffect, useContext, useRef } from 'react';

import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSectionCombination from 'components/layout_and_quote_builder/LayoutNavSectionCombination.jsx';

// `selected` (optional) draws a brand outline around the card -- used by the guided setup wizard to show
// which solution card is currently marked. It is an OUTLINE, not a border, so it adds no box and cannot
// disturb the flex `flex: 0 0 25%` card sizing. Absent everywhere else, so those cards are unchanged.
// `columnBasis` (optional) overrides that 25% flex basis -- the wizard passes a wider one (33.333%) so its
// narrower modal shows 3 cards per row instead of 4. Absent -> the .combinations_grid_item_cont 25% stands.
// `dimmed` (optional) fades the card to 0.8 opacity -- the Solution tab dims the un-selected solutions so the
// selected one stands out. Absent everywhere else.
const LayoutNavSectionCombinationListList = ({
  list, count, setSelectedList, selected = false, columnBasis = null, dimmed = false,
}) => {
  const [totalScore, setTotalScore] = useState(0)
  const [totalScoreList, setTotalScoreList] = useState({})
  const [numTotals, setNumTotals] = useState( {} )
  const [numTotalsPrinting, setNumTotalsPrinting] = useState( {} )
  const [numOfDrawingsInSet, setNumOfDrawingsInSet] = useState( {} )

  const handleClick = () => {
    setSelectedList( list )
  }

  const showNavSectionCombination = ( result, index ) => {
    return <LayoutNavSectionCombination
      index = {index}
      diecutting_result={result.diecutting_result}
      nav_section_id={result.nav_section_id}
      count={count}
      layout_dimension={result.material_layout_dimension}
      setTotalScoreList={setTotalScoreList}
      setNumTotals={setNumTotals}
      setNumTotalsPrinting={setNumTotalsPrinting}
      setNumOfDrawingsInSet={setNumOfDrawingsInSet}
    />
  }

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_total_diecutting = numTotals[i]
      list[i].num_total_printing   = numTotalsPrinting[i]
    }
  }, [numTotals, numTotalsPrinting] )


  useEffect( () => {
    setTotalScore( () => Object.values(totalScoreList).reduce((a, b) => a + b, 0)  )
  }, [totalScoreList])

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_of_drawings_in_set = numOfDrawingsInSet[i]
    }
  }, [numOfDrawingsInSet] )

  return (
    <div
      className={styles.combinations_grid_item_cont}
      key={name}
      data-score={totalScore}
      onClick={handleClick}
      style={{
        ...(columnBasis ? { flex: `0 0 ${columnBasis}`, maxWidth: columnBasis } : {}),
        ...(selected ? { outline: '3px solid var(--brand, #eb5424)', outlineOffset: '-3px' } : {}),
        ...(dimmed ? { opacity: 0.8 } : {}),
      }}
    >
      <div className={styles.card_top_bar}>
        <div style={{fontSize: '12px' }} className="stars-rating-container"></div>
      </div>

      {list.map((result, index) => (
        <React.Fragment key={index}>
          {showNavSectionCombination(result, index)}
        </React.Fragment>
      ))}
    </div>
  )
}

export default LayoutNavSectionCombinationListList;
